import React from 'react';
const QuarterDisplay = () => {
    const now = new Date();
    const currentMonth = now.getMonth(); // 0-11
    // Determine quarter and calculate progress
    let quarter, quarterStart, quarterEnd;
    if (currentMonth < 3) {
        quarter = 'Q1';
        quarterStart = new Date(now.getFullYear(), 0, 1); // Jan 1
        quarterEnd = new Date(now.getFullYear(), 2, 31); // Mar 31
    }
    else if (currentMonth < 6) {
        quarter = 'Q2';
        quarterStart = new Date(now.getFullYear(), 3, 1); // Apr 1
        quarterEnd = new Date(now.getFullYear(), 5, 30); // Jun 30
    }
    else if (currentMonth < 9) {
        quarter = 'Q3';
        quarterStart = new Date(now.getFullYear(), 6, 1); // Jul 1
        quarterEnd = new Date(now.getFullYear(), 8, 30); // Sep 30
    }
    else {
        quarter = 'Q4';
        quarterStart = new Date(now.getFullYear(), 9, 1); // Oct 1
        quarterEnd = new Date(now.getFullYear(), 11, 31); // Dec 31
    }
    // Calculate progress through the quarter (0 to 1)
    const totalDays = Math.ceil((quarterEnd.getTime() - quarterStart.getTime()) / (1000 * 60 * 60 * 24));
    const daysPassed = Math.ceil((now.getTime() - quarterStart.getTime()) / (1000 * 60 * 60 * 24));
    const quarterProgress = Math.min(Math.max(daysPassed / totalDays, 0), 1);
    // Calculate text color based on progress
    // Orange (255, 165, 0) to White (255, 255, 255)
    const orangeR = 255;
    const orangeG = 165;
    const orangeB = 0;
    const whiteR = 255;
    const whiteG = 255;
    const whiteB = 255;
    const currentR = Math.round(orangeR + (whiteR - orangeR) * quarterProgress);
    const currentG = Math.round(orangeG + (whiteG - orangeG) * quarterProgress);
    const currentB = Math.round(orangeB + (whiteB - orangeB) * quarterProgress);
    const textColor = `rgb(${currentR}, ${currentG}, ${currentB})`;
    return (React.createElement("div", { style: { color: textColor } }, quarter));
};
export default QuarterDisplay;
